<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/prepartion/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdan')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('huanmuzhuangtai')">
            <yi_dictionary_select :type="'PREPARATION_DIE_CHANGE_STATUS'" :ids.sync="yt.conditions.dieChangeStatus"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('beiliaozhuangtai')">
            <el-select v-model="yt.conditions.stockStatus">
              <el-option :label="$t('weichuli')" :value="0"></el-option>
              <el-option :label="$t('yiwancheng')" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('tiaojizhuangtai')">
            <yi_dictionary_select :type="'PREPARATION_DEBUG_EQUIPMENT_STATUS'" :ids.sync="yt.conditions.debugEquipmentStatus"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifousongjian')">
            <yi_dictionary_select :type="'SYSTEM_YES_NO'" :ids.sync="yt.conditions.isSent"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifouteshusongjian')">
            <yi_dictionary_select :type="'SYSTEM_YES_NO'" :ids.sync="yt.conditions.isSpecialSent"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('beimozhuangtai')">
            <yi_dictionary_select :type="'MOLD_PREPARATION_STATUS'" :ids.sync="yt.conditions.moldPrepareStatus"></yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('guishuchejian')">
            <yi_data_select :max="1" :type="'organization'" :ids.sync="yt.conditions.orgId"></yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc', woStatus: [1, 2, 3, 4, 5, 6, 7, 8] })">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button v-if="utils.checkPower('web_production_management_prenatal_preparation_batchMoldPrepare_wode')" size="mini" type="primary" @click="batchMoldDialogVisible = true" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '产前准备-批量备模' } }">
          {{ $t('批量备模') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->
      <template #beiliaozhuangtai="scope">
        <template v-if="scope.row.stockStatus == 0">
          <span>{{ $t('weichuli') }}</span>
        </template>
        <template v-if="scope.row.stockStatus == 1">
          <span>{{ $t('yiwancheng') }}</span>
        </template>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.dieChangeStatus == 0">
            <el-button type="text" @click="finishChange(scope.row)" :loading="scope.row.finishChangeLoading" v-if="utils.checkPower('web_production_prepartion')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '产前准备-换模完成' } }">
              {{ $t('huanmuwancheng') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.dieChangeStatus == 1">
            <el-button type="text" @click="cancelMold(scope.row)" :loading="scope.row.cancelMoldLoading" v-if="utils.checkPower('web_production_prepartion')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '产前准备-取消换模' } }">
              {{ $t('quxiaohuanmu') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.stockStatus == 0">
            <el-button type="text" @click="finishPreparation(scope.row)" :loading="scope.row.finishPreparationLoading" v-if="utils.checkPower('web_production_prepartion')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '产前准备-备料完成' } }">
              {{ $t('beiliaowancheng') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.stockStatus == 1">
            <el-button type="text" @click="cancelPreparation(scope.row)" :loading="scope.row.cancelPreparationLoading" v-if="utils.checkPower('web_production_prepartion')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '产前准备-取消备料' } }">
              {{ $t('quxiaobeiliao') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="moldPrepareConfigEnabled && scope.row.moldPrepareStatus == 0">
            <el-button type="text" @click="moldPrepare(scope.row)" :loading="scope.row.moldPrepareLoading" v-if="utils.checkPower('web_production_management_prenatal_preparation_moldPrepare')" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '产前准备-备模' } }">
              {{ $t('beimu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <batch_mold_prepare_dialog :visible.sync="batchMoldDialogVisible" @refreshed="yt.get(1)"></batch_mold_prepare_dialog>
  </div>
</template>
<script type="text/javascript">
import BatchMoldPrepareDialog from './batch_mold_prepare_dialog.vue';

export default {
  name: 'web_production_management_prenatal_preparation_list',
  components: {
    batch_mold_prepare_dialog: BatchMoldPrepareDialog
  },
  data() {
    return {
      moldPrepareConfigEnabled: false,
      batchMoldDialogVisible: false,
      columns: [
        {
          label: 'shengchangongdan',
          prop: 'no',
          width: 130
        },
        {
          label: 'guishuchejian',
          prop: 'org.name'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no'
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name'
        },
        {
          label: 'wuliaobianma',
          prop: 'basicMaterial.code'
        },
        {
          label: 'wuliaomingcheng',
          prop: 'basicMaterial.name'
        },
        {
          label: 'liaohao',
          prop: 'basicMaterial.no'
        },
        {
          label: 'yujizhuanchanshijian',
          prop: 'predictTime',
          type: 'time',
          width: 150
        },
        {
          label: 'beimokaishishijian',
          prop: 'moldPrepareStartTime',
          type: 'time',
          width: 150
        },
        {
          label: 'beimojieshushijian',
          prop: 'moldPrepareEndTime',
          type: 'time',
          width: 150
        },
        {
          label: 'zhuanmokaishishijian',
          prop: 'dieChangeStartTime',
          type: 'time',
          width: 150
        },
        {
          label: 'zhuanmojieshushijian',
          prop: 'dieChangeEndTime',
          type: 'time',
          width: 150
        },
        {
          label: 'huanmorenyuan',
          prop: 'dieChangerObject.nickname'
        },
        {
          label: 'tiaojikaishishijian',
          prop: 'debugEquipmentStartTime',
          type: 'time',
          width: 150
        },
        {
          label: 'tiaojijieshushijian',
          prop: 'debugEquipmentEndTime',
          type: 'time',
          width: 150
        },
        {
          label: 'tiaojirenyuan',
          prop: 'equipmentDebuggerObject.nickname'
        },
        {
          label: 'shifousongjian',
          prop: 'isSent',
          type: 'dictionary',
          key: 'SYSTEM_YES_NO'
        },
        {
          label: 'jianyandanhao',
          prop: 'inspection.inspectionNo',
          width: 130
        },
        {
          label: 'shoujiancishu',
          prop: 'firstInspectionCount',
          width: 130
        },
        {
          label: 'shoujianyongshi',
          prop: 'firstInspectionUseTime',
          width: 130
        },
        {
          label: 'jianyanrenyuan',
          prop: 'inspectorObject.nickname'
        },
        {
          label: 'tiaojizhuangtai',
          prop: 'debugEquipmentStatus',
          type: 'dictionary_tag',
          key: 'PREPARATION_DEBUG_EQUIPMENT_STATUS'
        },
        {
          label: 'huanmuzhuangtai',
          prop: 'dieChangeStatus',
          type: 'dictionary_tag',
          key: 'PREPARATION_DIE_CHANGE_STATUS'
        },
        {
          label: 'beiliaozhuangtai',
          prop: 'status',
          type: 'slot'
        },
        {
          label: 'mujuchukudanhao',
          prop: 'moldOutboundNo',
          width: 130
        },
        {
          label: 'beimozhuangtai',
          prop: 'moldPrepareStatus',
          type: 'dictionary_tag',
          key: 'MOLD_PREPARATION_STATUS'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 220,
          fixed: 'right'
        }
      ]
    };
  },

  created() {
    this.getMoldPrepareConfig();
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc',
        woStatus: [1, 2, 3, 4, 5, 6, 7, 8]
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    getMoldPrepareConfig() {
      this.http.get('/web/production/config/list?type=18&status=1').then(res => {
        if (res.data && res.data.length > 0) {
          this.moldPrepareConfigEnabled = true;
        }
      });
    },
    finishChange(editObj) {
      this.$set(editObj, 'finishChangeLoading', true);
      let params = editObj;
      params.dieChangeStatus = 1;
      this.http
        .post('/web/prepartion/update', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        })
        .finally(() => {
          this.$set(editObj, 'finishChangeLoading', false);
        });
    },
    cancelMold(editObj) {
      let params = editObj;
      this.$set(editObj, 'cancelMoldLoading', true);
      params.dieChangeStatus = 0;
      this.http
        .post('/web/prepartion/update', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        })
        .finally(() => {
          this.$set(editObj, 'cancelMoldLoading', false);
        });
    },
    finishPreparation(editObj) {
      let params = editObj;
      params.stockStatus = 1;
      this.$set(editObj, 'finishPreparationLoading', true);
      this.http
        .post('/web/prepartion/update', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        })
        .finally(() => {
          this.$set(editObj, 'finishPreparationLoading', false);
        });
    },
    cancelPreparation(editObj) {
      let params = editObj;
      this.$set(editObj, 'cancelPreparationLoading', true);
      params.stockStatus = 0;
      this.http
        .post('/web/prepartion/update', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        })
        .finally(() => {
          this.$set(editObj, 'cancelPreparationLoading', false);
        });
    },
    moldPrepare(editObj) {
      this.$confirm(this.$t('是否确认备模?'), this.$t('tishi'), {
        confirmButtonText: this.$t('queding'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      })
        .then(() => {
          this.$set(editObj, 'moldPrepareLoading', true);
          this.http
            .post('/web/prepartion/moldPrepare', editObj.id)
            .then(res => {
              this.utils.successMessage(this.$t(res.msg));
              this.yt.get(1);
            })
            .catch(msg => {
              this.utils.errorMessage(msg);
            })
            .finally(() => {
              this.$set(editObj, 'moldPrepareLoading', false);
            });
        })
        .catch(() => {});
    }
  }
};
</script>
